import { takeEvery } from 'redux-saga/effects'
import abstractDuck from '../helpers/singleActionDuck'

const apiUrl = `${process.env.REACT_APP_API_URL}/notifications/:id/read`
const name = 'notificationMarkRead'
const { types, actions, sagas, selectors, reducers } = abstractDuck({ name, apiUrl, method: 'PATCH' })

export const slice = {
  types,
  actions,
  sagas: [takeEvery(types.ACTION, sagas[name])],
  selectors
}

export default reducers
